<div class="card">
  <div class="card-header card-header-dark d-flex align-items-center justify-content-between">
    <span><i class="fa-duotone fa-light-emergency-on"></i> {{'ALARM_REASONS' |translate}}</span>
    @if (!showEditForm) {
      <button
        class="btn btn-outline-primary mr-5"
        (click)="showEditForm = true">
        {{ 'MODIFY' | translate}}
      </button>
    }
    @if (showEditForm) {
      <div class="mr-5 d-flex-column">
        <div class="d-flex justify-content-end">
          <button type="reset" class="btn btn-outline-primary" (click)="onExitForm()"><span
          class="fal fa-times"></span> {{'CANCEL' |translate}}</button>
          <button [disabled]="!editAlarms.valid"
            type="submit"
            class="btn btn-primary"
            appThrottleClick
            (throttledClick)="onSubmit()">
            <span class="fa-light fa-fw fa-floppy-disk"></span>
            {{'SAVE' |translate}}
          </button>
        </div>
        @if (!editAlarms.valid) {
          <span class="validationNotice">{{'ALARM_REASON_NAMES_VALIDATION' |translate}}</span>
        }
      </div>
    }
  </div>

  <!-- LIST of alarm reasons inside of each category -->
  @if (!showEditForm) {
    <div class="card-body card-body-dark" cdkDropListGroup>
      @for (item of arrayOfTableData; track item; let i = $index) {
        <mat-expansion-panel
          [expanded]="true"
          class="mb-5">
          <mat-expansion-panel-header class="indicator">
            <mat-panel-title>
              @for (categoryName of item.categoryNames; track categoryName; let j = $index) {
                <div class="categoryNames"
                  [ngStyle]="sortingIndex === j ? {'background-color': '#DDE3ED'}:null"
                  >{{categoryName}}
                </div>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <table
            class="drag-and-drop-list table table-striped">
            <thead>
              @if (!item.alarms.length == 0) {
                <tr class="noBorder pointer">
                  <td></td>
                  <!-- <td class='positionIndex'></td> -->
                  @for (language of columnLanguages; track language; let k = $index) {
                    <td
                      (click)="resetSortingIndex(k)">{{language}}
                      <i class="fa-solid fa-sort text-secondary"></i>
                    </td>
                  }
                </tr>
              }
            </thead>
            <tbody cdkDropList
              id="{{item.categoryID}}"
              [cdkDropListData]="item.alarms"
              (cdkDropListDropped)="drop($event)"
              class="drag-and-drop-list">
              @if (item.alarms.length == 0) {
                <tr class="preventCollapseDropArea">
                  <td></td>
                  <!-- <td class='positionIndex'></td> -->
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              }
              @for (translatedNames of item.alarms; track translatedNames) {
                <tr
                  cdkDrag
                  class="drag-and-drop-box">
                  <td cdkDragHandle>
                    <i class="fa-solid fa-grip-dots-vertical my-auto"></i>
                  </td>
                  <!-- <td class='positionIndex'>{{ translatedNames.positionIndex }}</td> -->
                  @for (alarmName of translatedNames.names; track alarmName; let j = $index) {
                    <td class="alarmNameCell"
                      [ngStyle]="sortingIndex === j ? {'background-color': '#DDE3ED','border': '1px solid #DADADA'}:null"
                    >{{ alarmName }}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </mat-expansion-panel>
      }
    </div>
  }

  <!-- FORM for editing of alarm reasons and their categories -->
  @if (showEditForm) {
    <div class="card-body card-body-dark">
      <button class="btn btn-outline-primary m-2" type='button' (click)="addCategory(); $event.preventDefault();  $event.stopPropagation()">
        {{ 'ADD_CATEGORY' | translate}}
      </button>
      <!-- *ngIf="editAlarms" -->
      <form [formGroup]="editAlarms">
        <div formArrayName="categories">
          @for (category of getCategoryArray().controls; track category; let i = $index) {
            <div>
              <div [formGroupName]="i">
                <div class="d-flex justify-content-around">
                  @for (column of columnNames; track column) {
                    <span>
                      {{column}} <i class="fa-solid fa-sort"></i>
                    </span>
                  }
                </div>
                <div class="input-group">
                  <input class="form-control text-center fromCategoryNames"
                    formControlName="alarmReasonCategory_EN"
                    type="text"
                    id="{{'categoryName' + i}}"
                                [ngClass]="{invalidInput: (category.get('alarmReasonCategory_EN').touched ||
                                                            category.get('alarmReasonCategory_EN').dirty) &&
                                                            !category.get('alarmReasonCategory_EN').valid}">
                    <input class="form-control text-center fromCategoryNames"
                      formControlName="alarmReasonCategory_FI"
                      type="text"
                      id="{{'categoryName' + i}}"
                                [ngClass]="{invalidInput: (category.get('alarmReasonCategory_FI').touched ||
                                                            category.get('alarmReasonCategory_FI').dirty) &&
                                                            !category.get('alarmReasonCategory_FI').valid}">
                      <input class="form-control text-center fromCategoryNames"
                        formControlName="alarmReasonCategory_SE"
                        type="text"
                        id="{{'categoryName' + i}}"
                                [ngClass]="{invalidInput: (category.get('alarmReasonCategory_SE').touched ||
                                                            category.get('alarmReasonCategory_SE').dirty) &&
                                                            !category.get('alarmReasonCategory_SE').valid}">
                        <input class="form-control text-center fromCategoryNames"
                          formControlName="alarmReasonCategory_EE"
                          type="text"
                          id="{{'categoryName' + i}}"
                                [ngClass]="{invalidInput: (category.get('alarmReasonCategory_EE').touched ||
                                                            category.get('alarmReasonCategory_EE').dirty) &&
                                                            !category.get('alarmReasonCategory_EE').valid}">
                          <button (click)="removeCategory(i); $event.preventDefault();  $event.stopPropagation()"
                            type='button'
                            mat-button
                            matTooltip="{{'REMOVE_CATEGORY' |translate}}"
                            matTooltipPosition="above"
                            matTooltipClass="customTooltipStyle"
                            matTooltipShowDelay="50"
                            matTooltipHideDelay="150">
                            <i class="fa-duotone fa-trash-can redTrashCan"></i>
                          </button>
                        </div>
                        <div formArrayName="alarmReasons"
                          class="drag-and-drop-list"
                          id="{{i}}">
                          @for (alarm of getAlarmReasonsArray(i).controls; track alarm; let j = $index) {
                            <div
                              class="alarmReasonRow">
                              <div [formGroupName]="j" class="input-group drag-and-drop-box">
                                <input class="form-control"
                                  formControlName="alarmReason_EN"
                                  type="text"
                                  id="{{'alarmReason' + j + i}}">
                                  <input class="form-control"
                                    formControlName="alarmReason_FI"
                                    type="text"
                                    id="{{'alarmReason' + j + i}}">
                                    <input class="form-control"
                                      formControlName="alarmReason_SE"
                                      type="text"
                                      id="{{'alarmReason' + j + i}}">
                                      <input class="form-control"
                                        formControlName="alarmReason_EE"
                                        type="text"
                                        id="{{'alarmReason' + j + i}}">
                                        <button (click)="removeAlarm(i, j); $event.preventDefault();  $event.stopPropagation()"
                                          type='button'
                                          mat-button
                                          matTooltip="{{'REMOVE_ALARM_REASON' |translate}}"
                                          matTooltipPosition="above"
                                          matTooltipClass="customTooltipStyle"
                                          matTooltipShowDelay="50"
                                          matTooltipHideDelay="150">
                                          <i class="fa-duotone fa-trash-can redTrashCan"></i>
                                        </button>
                                      </div>
                                    </div>
                                  }
                                </div>
                                <button class="btn btn-outline-primary mt-2 mb-4" type='button' (click)="addAlarm(i); $event.preventDefault();  $event.stopPropagation()">
                                  {{'ADD_ALARM_REASON'| translate}}
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      </form>
                      <!-- <p>{{ editAlarms.value | json }}</p> -->
                    </div>
                  }
                </div>
